import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '@app/core/models/question/question-base';
import { formatStringToCurrency, formatCurrencyToString } from '@app/features/coverage/coverage';
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import * as moment from 'moment';
import { DropdownQuestion } from '@app/core/models/question/dropdown-question';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html'
})

export class QuestionComponent implements OnInit {
  @Input() question: QuestionBase<any>;
  @Input() id: string;
  @Input() form: FormGroup;
  @Output() dropdownChanged: EventEmitter<{ key: string, value: string }> = new EventEmitter();
  @Output() nextQuestion = new EventEmitter();

  formatStringToCurrency: any;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    minYear: 1900,
    maxYear: 2100,
    editableDateField: false,
    markCurrentDay: true,
    alignSelectorRight: true
  };
  selDate: IMyDate = null;
  optionSelected: string;

  constructor() {
    this.formatStringToCurrency = this.customFormatStringToCurrency;
  }

  ngOnInit() {
    if (this.question instanceof DropdownQuestion) {
      this.optionSelected = this.question.options[0].key;
      this.onDropdownChanged(this.optionSelected);
    }
    if (this.question.key === 'renewableDate') {
      const date = moment().utc().add(1, 'year');
      this.form.controls[this.question.key].setValue(date.format('DD/MM/YYYY'));
      this.selDate = {
        year: date.year(),
        month: date.month() + 1,
        day: date.date()
      };
    }
    this.id = `question-${this.id}`;
  }

  get isRequired() {
    return this.form.controls[this.question.key].errors && this.form.controls[this.question.key].errors.required;
  }

  customFormatStringToCurrency(amount: string) {
    return amount ? `$${formatStringToCurrency(amount.toString().replace('$', ''))}` : amount;
  }

  onDropdownChanged(selectedOption) {
    this.dropdownChanged.emit({
      key: this.question.key,
      value: selectedOption
    });
  }

  handleKeyDown(event) {
    if (event.keyCode === 8) {
      return;
    }

    if (event.keyCode === 13) {
      this.nextQuestion.emit(this.id);
      return;
    }

    if (event.keyCode === 46) {
      if (!event.target.value) {
        event.preventDefault();
      } else if (event.target.value.includes('.')) {
        event.preventDefault();
      } else {
        return;
      }
    } else if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
  }

  handleInputNumber(event, key) {
    this.form.controls[key].setValue(formatCurrencyToString(event.target.value.toString().replace('$', '')));
  }

  preventInputDate(event) {
    event.preventDefault();
  }

  handleInputDate(event, key) {
    this.form.controls[key].setValue(moment().year(event.date.year).month(event.date.month - 1).date(event.date.day).format('DD/MM/YYYY'));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/question/question.component.ts